import { FilterItemColumnType } from "namirasoft-core";
import { BaseTypeBuilder } from "./BaseTypeBuilder";
import { AnySchema } from "./schema/type/AnySchema";
import { VariableType } from "./schema/VariableType";
import { BaseTypeSchema } from "./schema/BaseTypeSchema";

export class FilterItemColumnTypeBuilder extends BaseTypeBuilder<FilterItemColumnType>
{
    constructor(type: VariableType)
    {
        super({ type } as BaseTypeSchema);
    }
    /* VariableType */
    protected override _toAny(_: AnySchema)
    {
        return FilterItemColumnType.Unknown;
    }
    protected override _toBool()
    {
        return FilterItemColumnType.Boolean;
    }
    protected override _toTinyInt()
    {
        return FilterItemColumnType.Number;
    }
    protected override _toSmallInt()
    {
        return FilterItemColumnType.Number;
    }
    protected override _toMediumInt()
    {
        return FilterItemColumnType.Number;
    }
    protected override _toInteger()
    {
        return FilterItemColumnType.Number;
    }
    protected override _toBigInt()
    {
        return FilterItemColumnType.Number;
    }
    protected override _toFloat()
    {
        return FilterItemColumnType.Number;
    }
    protected override _toDouble()
    {
        return FilterItemColumnType.Number;
    }
    protected override _toDecimal()
    {
        return FilterItemColumnType.Number;
    }
    protected override _toReal()
    {
        return FilterItemColumnType.Number;
    }
    protected override _toMoney()
    {
        return FilterItemColumnType.Number;
    }
    protected override _toString()
    {
        return FilterItemColumnType.String;
    }
    protected override _toDate()
    {
        return FilterItemColumnType.Date;
    }
    protected override _toTime()
    {
        return FilterItemColumnType.Time;
    }
    protected override _toDateTime()
    {
        return FilterItemColumnType.DateTime;
    }
    protected override _toTimeZone()
    {
        return FilterItemColumnType.String;
    }
    protected override _toDuration()
    {
        return FilterItemColumnType.String;
    }
    protected override _toEmail()
    {
        return FilterItemColumnType.String;
    }
    protected override _toPhone()
    {
        return FilterItemColumnType.String;
    }
    protected override _toVersion()
    {
        return FilterItemColumnType.String;
    }
    protected override _toIPV4()
    {
        return FilterItemColumnType.String;
    }
    protected override _toIPV6()
    {
        return FilterItemColumnType.String;
    }
    protected override _toIPV4Range()
    {
        return FilterItemColumnType.String;
    }
    protected override _toIPV6Range()
    {
        return FilterItemColumnType.String;
    }
    protected override _toColor()
    {
        return FilterItemColumnType.String;
    }
    protected override _toFont()
    {
        return FilterItemColumnType.String;
    }
    protected override _toFilePath()
    {
        return FilterItemColumnType.String;
    }
    protected override _toURL()
    {
        return FilterItemColumnType.String;
    }
    protected override _toEnum()
    {
        return FilterItemColumnType.String;
    }
    protected override _toEntity()
    {
        return FilterItemColumnType.String;
    }
    protected override _toArray()
    {
        return FilterItemColumnType.Unknown;
    }
    protected override _toObject()
    {
        return FilterItemColumnType.Unknown;
    }
    protected override _toType()
    {
        return FilterItemColumnType.String;
    }
    protected override _toVariable()
    {
        return FilterItemColumnType.String;
    }
}